import { createContext, useContext } from 'react';
export const OnToggleFunctionsContext = /*#__PURE__*/createContext(undefined);
export const useOnToggleFunctions = () => {
  const context = useContext(OnToggleFunctionsContext);
  if (!context) {
    throw new Error('tried to call useOnToggleFunctions when empty ');
  }
  return context;
};
//# sourceMappingURL=use-on-toggle-functions.js.map